
import {ConfirmationDialogData} from '../../../../core/interfaces/confirmation-dialog-data';

export enum ConfirmationDialogs {
	DEACTIVATE,
	REACTIVATE,
	DELETE,
	DELEGATE,
	GUEST_ACCESS,
	NAVIGATION,
	REMOVE,
	REVERT,
	UNSAVED_CHANGES,
	UNSAVED_CHANGES_DETECTED,
	DATA_RESET,
	REMOVE_SSO_CONFIRMATION,
	REMOVE_MEETINGS_CONFIRMATION,
	REMOVE_OFFICE365_CONFIRMATION,
	OFFICE365_CONSENT_SUCCESS,
	OFFICE365_CONSENT_FAILURE,
	REMOVE_CCNEXT_CONFIRMATION,
	REMOVE_WORKGROUPS_CONFIRMATION,
	REMOVE_VOICEASSIST_CONFIRMATION,
	REMOVE_MITELONE_CONFIRMATION,
	SESSION_EXPIRED_CLOSE,
	SESSION_EXPIRED_LOGOUT,
	DELETE_USER,
	DELETE_USERS,
	MV400_CX_SETUP_FAILURE,
	REMOVE_MITEL5000_CONFIRMATION,
	REMOVE_MSTEAMS_CONFIRMATION,
	ERROR_WORKFLOW_CREATION,
	ERROR_MISSING_CONNECTOR,
	MVA_SETUP_FAILURE,
	MIVB_REMOVE_CONFIRMATION,
	MIVB_SETUP_FAILURE,
	REMOVE_MICC_CONFIRMATION,
	REMOVE_MICCB_USER_PRODUCT_CONFIRMATION,
	REMOVE_MICCB_USER_PRODUCT_LIMITEDACCESS_CONFIRMATION,
	REMOVE_TWILIO_CONFIRMATION,
	REMOVE_CMCOM_CONFIRMATION,
	MSTEAMS_MONITOR_CONSENT_SUCCESS,
	MSTEAMS_MONITOR_CONSENT_FAILURE,
	REMOVE_WORKFLOW_STUDIO_CONFIRMATION,
	DISABLE_MSTEAMS_TO_CLOUDLINK_CONFIRMATION,
	DEACTIVATE_FEATURE_FLAG,
	RELEASE_FEATURE_FLAG,
	DELETE_FEATURE_FLAG,
	REMOVE_ZAPPA_CONFIRMATION,
	REMOVE_UNIFY_PHONE_CONFIRMATION
}

export namespace ConfirmationDialogsGetter {
	export function getDialogData(mode: ConfirmationDialogs, flags?:any): ConfirmationDialogData {
		switch (mode) {
			case ConfirmationDialogs.DELETE: {
				return {
					titleKey: 'deleteConfirmation.deleteCustomer',
					descriptionKey: 'deleteConfirmation.deleteCustomerDesc',
					placeholderKey: 'common.placeholderDelete',
					messageWarningKey: 'deleteConfirmation.warning',
					messageKey: 'deleteConfirmation.dataResetWarning',
					typeAndContinue: 'deleteConfirmation.typeAndContinue',
					passKey: 'deleteConfirmation.delete',
					actionButtonKey: 'buttons.delete',
					cancelButtonKey: 'buttons.cancel'
				};
			}
			case ConfirmationDialogs.NAVIGATION: {
				return {
					titleKey: 'navigation_confirmation.title',
					descriptionKey: 'navigation_confirmation.content',
					actionButtonKey: 'navigation_confirmation.leave',
					cancelButtonKey: 'navigation_confirmation.stay'
				};
			}
			case ConfirmationDialogs.DEACTIVATE: {
				return {
					titleKey: 'deactivateConfirmation.deactivateCustomer',
					descriptionKey: 'deactivateConfirmation.deactivateCustomerDesc',
					placeholderKey: 'common.placeholderDeactivate',
					typeAndContinue: 'deactivateConfirmation.typeAndContinue',
					passKey: 'deactivateConfirmation.deactivate',
					actionButtonKey: 'buttons.deactivate',
					tooltipsKey: 'tooltips.deactivateHelp',
					cancelButtonKey: 'buttons.cancel'
				};
			}
			case ConfirmationDialogs.REACTIVATE: {
				return {
					titleKey: 'reactivateConfirmation.reactivateCustomer',
					descriptionKey: 'reactivateConfirmation.reactivateCustomerDesc',
					placeholderKey: 'common.placeholderReactivate',
					typeAndContinue: 'reactivateConfirmation.typeAndContinue',
					passKey: 'reactivateConfirmation.reactivate',
					actionButtonKey: 'buttons.reactivate',
					tooltipsKey: 'tooltips.reactivateHelp',
					cancelButtonKey: 'buttons.cancel'
				};
			}
			case ConfirmationDialogs.REMOVE: {
				return {
					titleKey: 'removeConfirmation.title',
					descriptionKey: 'removeConfirmation.description',
					placeholderKey: 'common.placeholderRemove',
					typeAndContinue: 'removeConfirmation.typeAndContinue',
					passKey: 'removeConfirmation.remove',
					actionButtonKey: 'buttons.removeAdmin',
					cancelButtonKey: 'buttons.cancel'
				};
			}
			case ConfirmationDialogs.DELEGATE: {
				return {
					titleKey: 'delegateConfirmation.title',
					descriptionKey: 'delegateConfirmation.description',
					placeholderKey: 'common.placeholderConfirm',
					typeAndContinue: 'delegateConfirmation.typeAndContinue',
					passKey: 'delegateConfirmation.delegate',
					actionButtonKey: 'buttons.delegate',
					messageKey: 'delegateConfirmation.message',
					messageWarningKey: 'delegateConfirmation.warning',
					cancelButtonKey: 'buttons.cancel'
				};
			}
			case ConfirmationDialogs.GUEST_ACCESS: {
				return {
					titleKey: 'guestAccess.title',
					descriptionKey: 'guestAccess.description',
					placeholderKey: 'common.placeholderAllow',
					typeAndContinue: 'guestAccess.typeAndContinue',
					passKey: 'guestAccess.allow',
					actionButtonKey: 'buttons.confirm',
					cancelButtonKey: 'buttons.cancel'
				};
			}
			case ConfirmationDialogs.REVERT: {
				return {
					titleKey: 'revertFormConfirmation.title',
					descriptionKey: 'revertFormConfirmation.description',
					actionButtonKey: 'revertFormConfirmation.revert',
					cancelButtonKey: 'buttons.cancel'
				};
			}
			case ConfirmationDialogs.UNSAVED_CHANGES: {
				return {
					titleKey: 'unsavedChangesConfirmation.title',
					descriptionKey: 'unsavedChangesConfirmation.description',
					actionButtonKey: 'unsavedChangesConfirmation.save',
					cancelButtonKey: 'unsavedChangesConfirmation.doNotSave'
				};
			}
			case ConfirmationDialogs.UNSAVED_CHANGES_DETECTED: {
				return {
					titleKey: 'unsavedChangesDetected.title',
					descriptionKey: 'unsavedChangesDetected.description',
					actionButtonKey: 'unsavedChangesDetected.ok'
				};
			}
			case ConfirmationDialogs.DATA_RESET: {
				return {
					titleKey: 'dataResetConfirmation.title',
					descriptionKey: 'dataResetConfirmation.description',
					placeholderKey: 'common.placeholderRevert',
					typeAndContinue: 'dataResetConfirmation.typeAndContinue',
					actionButtonKey: 'buttons.confirm',
					messageWarningKey: 'dataResetConfirmation.warning',
					passKey: 'dataResetConfirmation.revert',
					cancelButtonKey: 'buttons.cancel'
				}
			}
			case ConfirmationDialogs.REMOVE_SSO_CONFIRMATION: {
				return {
					titleKey: 'integrations.sso.remove-sso-confirm-title',
					descriptionKey: 'integrations.sso.remove-sso-description',
					actionButtonKey: 'integrations.remove-button',
					cancelButtonKey: 'buttons.cancel'
				}
			}
			case ConfirmationDialogs.REMOVE_MEETINGS_CONFIRMATION: {
				return {
					titleKey: 'integrations.remove-meetings-confirm-title',
					descriptionKey: 'integrations.remove-meetings-description',
					actionButtonKey: 'integrations.OK-button',
				}
			}
			case ConfirmationDialogs.REMOVE_OFFICE365_CONFIRMATION: {
				return {
					titleKey: 'integrations.office365.remove-office365-confirm-title',
					descriptionKey: 'integrations.office365.remove-office365-description',
					actionButtonKey: 'integrations.remove-button',
					cancelButtonKey: 'buttons.cancel'
				}
			}
			case ConfirmationDialogs.OFFICE365_CONSENT_SUCCESS: {
				return {
					titleKey: 'integrations.office365.consent-success-title',
					descriptionKey: 'integrations.office365.consent-success-next-steps',
					actionButtonKey: 'integrations.OK-button'
				}
			}
			case ConfirmationDialogs.OFFICE365_CONSENT_FAILURE: {
				return {
					titleKey: 'integrations.office365.consent-failure-title',
					descriptionKey: 'integrations.office365.consent-failure-next-steps',
					actionButtonKey: 'integrations.OK-button'
				}
			}
			case ConfirmationDialogs.REMOVE_CCNEXT_CONFIRMATION: {
				return {
					titleKey: 'integrations.cc-next.remove-ccnext-confirm-title',
					descriptionKey: 'integrations.cc-next.remove-ccnext-description',
					actionButtonKey: 'integrations.remove-button',
					cancelButtonKey: 'buttons.cancel'
				}
			}
			case ConfirmationDialogs.REMOVE_WORKGROUPS_CONFIRMATION: {
				return {
					titleKey: 'integrations.workgroups.remove-wg-confirm-title',
					descriptionKey: 'integrations.workgroups.remove-wg-description',
					actionButtonKey: 'integrations.remove-button',
					cancelButtonKey: 'buttons.cancel'
				}
			}
			case ConfirmationDialogs.REMOVE_VOICEASSIST_CONFIRMATION: {
				return {
					titleKey: 'integrations.voice-assist.remove-feature-confirm-title',
					descriptionKey: 'integrations.voice-assist.remove-feature-description',
					actionButtonKey: 'integrations.remove-button',
					cancelButtonKey: 'buttons.cancel'
				}
			}
			case ConfirmationDialogs.REMOVE_MITELONE_CONFIRMATION: {
				return {
					titleKey: 'integrations.mitel-one.remove-confirm-title',
					descriptionKey: 'integrations.mitel-one.remove-description',
					actionButtonKey: 'integrations.remove-button',
					cancelButtonKey: 'buttons.cancel'
				}
			}
			case ConfirmationDialogs.SESSION_EXPIRED_CLOSE: {
				return {
					titleKey: 'session-expired.title',
					descriptionKey: 'session-expired.description-window-close',
					actionButtonKey: 'integrations.OK-button'
				}
			}
			case ConfirmationDialogs.SESSION_EXPIRED_LOGOUT: {
				return {
					titleKey: 'session-expired.title',
					descriptionKey: 'session-expired.description-logout',
					actionButtonKey: 'integrations.OK-button'
				}
			}
			case ConfirmationDialogs.DELETE_USER: {
				return {
					titleKey: 'deleteConfirmation.deleteUser',
					descriptionKey: 'deleteConfirmation.deleteUserDesc',
					messageWarningKey: flags && flags.showMiVBWarning? 'deleteConfirmation.integrationsAndPbxWarning' : null,
					placeholderKey: 'common.placeholderDelete',
					typeAndContinue: 'deleteConfirmation.typeAndContinue',
					passKey: 'deleteConfirmation.delete',
					actionButtonKey: 'buttons.delete',
					cancelButtonKey: 'buttons.cancel'
				};
			}
			case ConfirmationDialogs.DELETE_USERS: {
				return {
					titleKey: 'deleteConfirmation.deleteUsers',
					descriptionKey: 'deleteConfirmation.deleteUsersDesc',
					messageWarningKey: flags && flags.showMiVBWarning? 'deleteConfirmation.integrationsAndPbxWarning' : null,
					placeholderKey: 'common.placeholderDelete',
					typeAndContinue: 'deleteConfirmation.typeAndContinue',
					passKey: 'deleteConfirmation.delete',
					actionButtonKey: 'buttons.delete',
					cancelButtonKey: 'buttons.cancel'
				};
			}
			case ConfirmationDialogs.MV400_CX_SETUP_FAILURE: {
				return {
					titleKey: 'integrations.workgroups.cannot-setup-wg-feature-title',
					descriptionKey: 'integrations.workgroups.require-mitel-one-and-gw',
					actionButtonKey: 'integrations.OK-button'
				}
			}
			case ConfirmationDialogs.REMOVE_MITEL5000_CONFIRMATION: {
				return {
					titleKey: 'integrations.mivoice5000.remove-feature-confirm-title',
					descriptionKey: 'integrations.mivoice5000.remove-feature-description',
					actionButtonKey: 'integrations.remove-button',
					cancelButtonKey: 'buttons.cancel'
				}
			}
			case ConfirmationDialogs.REMOVE_MSTEAMS_CONFIRMATION: {
				return {
					titleKey: 'integrations.msteams.remove-feature-confirm-title',
					descriptionKey: 'integrations.msteams.remove-feature-description',
					actionButtonKey: 'integrations.remove-button',
					cancelButtonKey: 'buttons.cancel'
				}
			}
			case ConfirmationDialogs.ERROR_WORKFLOW_CREATION: {
				return {
					titleKey: 'integrations.generic-connector-dialog.error-title',
					descriptionKey: 'integrations.generic-connector-dialog.error-general-workflow-failed',
					actionButtonKey: 'integrations.OK-button'
				}
			}
			case ConfirmationDialogs.ERROR_MISSING_CONNECTOR: {
				return {
					titleKey: 'integrations.generic-connector-dialog.error-title',
					descriptionKey: 'integrations.generic-connector-dialog.error-connector-missing',
					actionButtonKey: 'integrations.OK-button'
				}
			}
			case ConfirmationDialogs.MVA_SETUP_FAILURE: {
				return {
					titleKey: 'integrations.voice-assist.cannot-setup-va-feature-title',
					descriptionKey: 'integrations.voice-assist.require-pbx-and-gw',
					actionButtonKey: 'integrations.OK-button'
				}
			}
			case ConfirmationDialogs.MIVB_REMOVE_CONFIRMATION: {
				return {
					titleKey: 'integrations.mivb.remove-feature-confirm-title',
					descriptionKey: 'integrations.mivb.remove-feature-description',
					actionButtonKey: 'integrations.remove-button',
					cancelButtonKey: 'buttons.cancel'
				}
			}
			case ConfirmationDialogs.MIVB_SETUP_FAILURE: {
				return {
					titleKey: 'integrations.mivb.cannot-setup-mivb-feature-title',
					descriptionKey: 'integrations.mivb.require-pbx-and-gw',
					actionButtonKey: 'integrations.OK-button'
				}
			}
			case ConfirmationDialogs.REMOVE_MICC_CONFIRMATION: {
				return {
					titleKey: 'integrations.micc-config.remove-feature-confirm-title',
					descriptionKey: 'integrations.micc-config.remove-feature-description',
					actionButtonKey: 'integrations.remove-button',
					cancelButtonKey: 'buttons.cancel'


				}
			}
			case ConfirmationDialogs.REMOVE_MICCB_USER_PRODUCT_CONFIRMATION: {
				return {
					titleKey: 'integrations.micc-config.users.remove-product-title',
					descriptionKey: 'integrations.micc-config.users.remove-product-description',
					actionButtonKey: 'integrations.remove',
					cancelButtonKey: 'buttons.cancel'
				}
			}
			case ConfirmationDialogs.REMOVE_MICCB_USER_PRODUCT_LIMITEDACCESS_CONFIRMATION: {
				return {
					titleKey: 'integrations.micc-config.users.remove-product-title',
					descriptionKey: 'integrations.micc-config.users.remove-product-description-limited-access',
					actionButtonKey: 'integrations.remove',
					cancelButtonKey: 'buttons.cancel'
				}
			}
			case ConfirmationDialogs.REMOVE_TWILIO_CONFIRMATION: {
				return {
					titleKey: 'integrations.twilio.remove-twilio-confirm-title',
					descriptionKey: 'integrations.twilio.remove-twilio-description',
					actionButtonKey: 'integrations.remove-button',
					cancelButtonKey: 'buttons.cancel'
				}
			}
			case ConfirmationDialogs.REMOVE_CMCOM_CONFIRMATION: {
				return {
					titleKey: 'integrations.cmcom.remove-cmcom-confirm-title',
					descriptionKey: 'integrations.cmcom.remove-cmcom-description',
					actionButtonKey: 'integrations.remove-button',
					cancelButtonKey: 'buttons.cancel'
				}
			}
			case ConfirmationDialogs.MSTEAMS_MONITOR_CONSENT_SUCCESS: {
				return {
					titleKey: 'integrations.MSTeamsToCLPresence.consent-success-title',
					descriptionKey: 'integrations.MSTeamsToCLPresence.consent-success-next-steps',
					actionButtonKey: 'integrations.OK-button'
				}
			}
			case ConfirmationDialogs.MSTEAMS_MONITOR_CONSENT_FAILURE: {
				return {
					titleKey: 'integrations.MSTeamsToCLPresence.consent-failure-title',
					descriptionKey: 'integrations.MSTeamsToCLPresence.consent-failure-next-steps',
					actionButtonKey: 'integrations.OK-button'
				}
			}
			case ConfirmationDialogs.REMOVE_WORKFLOW_STUDIO_CONFIRMATION: {
				return {
					titleKey: 'integrations.workflow-studio.remove-feature-confirm-title',
					descriptionKey: 'integrations.workflow-studio.remove-feature-description',
					actionButtonKey: 'integrations.remove-button',
					cancelButtonKey: 'buttons.cancel'
				}
			}
			case ConfirmationDialogs.DISABLE_MSTEAMS_TO_CLOUDLINK_CONFIRMATION: {
				return {
					titleKey: 'integrations.MSTeamsToCLPresence.disable-feature-confirm-title',
					descriptionKey: 'integrations.MSTeamsToCLPresence.disable-feature-description',
					actionButtonKey: 'buttons.confirm',
					cancelButtonKey: 'buttons.cancel'
				}
			}
			case ConfirmationDialogs.DEACTIVATE_FEATURE_FLAG: {
				return {
					titleKey: 'feature_flags.deactivate.title',
					descriptionKey: 'feature_flags.deactivate.descriptionKey',
					actionButtonKey: 'buttons.confirm',
					cancelButtonKey: 'buttons.cancel'
				}
			}
			case ConfirmationDialogs.RELEASE_FEATURE_FLAG: {
				return {
					titleKey: 'feature_flags.release.title',
					descriptionKey: 'feature_flags.release.descriptionKey',
					actionButtonKey: 'buttons.confirm',
					cancelButtonKey: 'buttons.cancel'
				}
			}
			case ConfirmationDialogs.DELETE_FEATURE_FLAG: {
				return {
					titleKey: 'feature_flags.delete.title',
					descriptionKey: 'feature_flags.delete.descriptionKey',
					actionButtonKey: 'buttons.confirm',
					cancelButtonKey: 'buttons.cancel'
				}
			}
			case ConfirmationDialogs.REMOVE_ZAPPA_CONFIRMATION: {
				return {
					titleKey: 'integrations.zappa.remove-zappa-confirm-title',
					descriptionKey: 'integrations.zappa.remove-zappa-description',
					actionButtonKey: 'integrations.remove-button',
					cancelButtonKey: 'buttons.cancel'
				}
			}
			case ConfirmationDialogs.REMOVE_UNIFY_PHONE_CONFIRMATION: {
				return {
					titleKey: 'integrations.unify-phone.remove-feature-confirm-title',
					descriptionKey: 'integrations.unify-phone.remove-feature-description',
					actionButtonKey: 'integrations.remove-button',
					cancelButtonKey: 'buttons.cancel'
				}
			}
		}
	}
}
